import styled, { css } from 'styled-components';
import { layout, colors } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';

type OptionProps = {
  selected?: boolean;
};

type CheckboxProps = {
  checked?: boolean;
};

type RadioButtonProps = {
  checked?: boolean;
};

export const OptionListItem = styled.li<OptionProps>``;

export const Option = styled(Clickable).attrs({
  'data-test': 'FilterOption',
})<OptionProps>`
  align-items: center;
  color: inherit;
  cursor: pointer;
  display: flex;
  text-align: left;
  width: 100%;
  padding: ${layout.spacing.xxSmall} ${layout.spacing.small};

  &:hover,
  &.focus-visible {
    color: ${({ theme }) => theme.text.callToActionHover};
  }
  ${props =>
    props.selected &&
    css`
      border: 1px solid ${colors.lightBlue1};
      border-radius: ${layout.borderRadius};
    `}
`;

export const Checkbox = styled.div<CheckboxProps>`
  margin-right: ${layout.spacing.xSmall};
  display: flex;
  background: ${colors.white};
  border: 1px solid ${colors.lightGray2};

  ${props =>
    props.checked &&
    css`
      background-color: ${colors.lightBlue1};
      border: 1px solid ${colors.lightBlue1};
    `}
`;

export const RadioButton = styled.div<RadioButtonProps>`
  display: inline-block;
  vertical-align: top;
  margin-left: 2px;
  margin-top: 2px;
  margin-right: 10px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background: ${colors.white};
  border: 1px solid ${colors.lightGray2};
  ${props =>
    props.checked &&
    css`
      background-color: ${colors.white};
      box-shadow: 0 0 0 1px ${colors.lightGray2};
      border: 5px solid ${colors.lightBlue1};
      color: ${colors.darkBlue1};
    `}
`;

export const Name = styled.span.attrs({ 'data-test': 'FilterOptionName' })`
  width: 100%;
`;

export const Count = styled.span.attrs({ 'data-test': 'FilterOptionCount' })``;
